import Carousel from 'nuka-carousel';
import { styled } from '@styledComponents';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';

export interface ImageStylesProps {
  width: number;
  height: number;
  top?: number;
  left?: number;
  right?: number;
  borderRadius?: string;
  zIndex?: number;
  show?: boolean;
  rotate?: number;
  showBoxShadow?: boolean;
}

export const StyledCarousel = styled(Carousel)`
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .slider-slide {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .slider-slide:not(.slide-visible) {
    animation-name: fadeOut;
  }

  .slider-frame {
    overflow: visible !important;
  }

  .slider-list {
    cursor: default !important;
  }
`;

export const ImagesWrapper = styled(Flex)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const BodyWrapper = styled(ImagesWrapper)`
  margin: auto;
  z-index: 3;
`;

export const StyledCloudImage = styled(CloudImage)<{ mobile: ImageStylesProps; sm: ImageStylesProps }>`
  ${props => {
    return {
      width: `${props.mobile.width}px`,
      height: 'auto',
      minHeight: `${props.mobile.height}px`,
    };
  }}
  margin-bottom: 21rem;
  ${themeMediaQuery('sm')} {
    ${props => {
      return {
        width: `${props.sm.width}px`,
        height: 'auto',
        minHeight: `${props.sm.height}px`,
      };
    }}
    margin-bottom: ${themeSpace(11)};
  }

`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-eyebrow {
    margin-bottom: ${themeSpace(6)};
  }

  .text-pairing-body {
    ${themeMediaQuery('sm')} {
      max-width: 420px;
    }

    ${themeMediaQuery('below_sm')} {
      max-width: 320px;
    }
  }
`;

export const Swiper = styled(Flex)`
  gap: ${themeSpace(4)};
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SwiperButton = styled(Flex)`
  cursor: pointer;
  border-radius: 100%;
  background-color: ${themeColor('white')};
  height: 48px;
  width: 48px;
  box-shadow: 0px 7px 27px ${themeColor('neutra6', 0.06)}, 0px 4px 16px rgba(0, 0, 0, 0.07);
`;

export const Wrapper = styled(Flex)`
  height: 1446px;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: 1070px;
  }
`;
